import { enquiryApiURl } from "API/urls/enquiry.api";
import { axiosInstance } from "configs/axios";

export const fetchEnquiriesApi = async (payload) => {
  try {
    const response = await axiosInstance.post(enquiryApiURl.getList, {
      ...payload,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
